export default class User {
  public userId: number = NaN;
  public userName: string = '';
  public password: string = '';
  public email: string = '';
  public firstName: string = '';
  public lastName: string = '';
}
